import { render, staticRenderFns } from "./ConnectUpgrade.vue?vue&type=template&id=dfebe47c"
import script from "./ConnectUpgrade.vue?vue&type=script&lang=js"
export * from "./ConnectUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports